import React from 'react';
import { create } from 'jss';
import rtl from 'jss-rtl';
import MomentUtils from '@date-io/moment';
import { jssPreset, StylesProvider, ThemeProvider } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import GlobalStyles from 'src/components/GlobalStyles';
import { createTheme } from './theme';
import usePreferences from './hooks/usePreferences';
import useRouteTo2 from './routes/useRouteTo2';
import { useEnv } from './hooks';

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
const PublicApp = () => {
  const { preferences } = usePreferences();
  const { routeType, router } = useRouteTo2();
  const { EGOV } = useEnv();
  const isGuestOrRegistry = ['Guest', 'Registry'].includes(routeType);

  const direction = isGuestOrRegistry ? 'ltr' : preferences.direction;
  const responsiveFontSizes = isGuestOrRegistry;
  const selectedTheme = isGuestOrRegistry
    ? EGOV
      ? 'IBFRS_THEME'
      : 'DEFAULT'
    : preferences.theme;
  const mode = isGuestOrRegistry ? 'light' : preferences.mode;

  const theme = React.useMemo(
    () =>
      createTheme({
        direction,
        responsiveFontSizes,
        theme: selectedTheme,
        mode,
        EGOV
      }),
    [preferences, routeType, EGOV]
  );

  return (
    <ThemeProvider theme={theme}>
      <StylesProvider jss={jss}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <GlobalStyles />
          {router}
        </MuiPickersUtilsProvider>
      </StylesProvider>
    </ThemeProvider>
  );
};

export default PublicApp;
